import { jsx as _jsx } from "react/jsx-runtime";
import MuiSkeleton from '@mui/material/Skeleton';
import * as React from 'react';
export const Skeleton = (props) => {
    return (_jsx(MuiSkeleton, { "data-role": "skeleton", ...props, sx: {
            ...(props.variant !== 'circular' && { borderRadius: 1 }),
            backgroundColor: (theme) => props?.color ?? theme.palette.action.hover,
            ...props.sx
        } }));
};
